import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import Testimonials from './components/Testimonials';
import Banner from './components/Banner';
import Services from './components/Services';
import TrustedBy from './components/TrustedBy';
import CoverageArea from './components/CoverageArea';
import BusinessInfo from './components/BusinessInfo';
import Partners from './components/Partners';
import WhatsNew from './components/WhatsNew';
import Quote from './components/Quote';

export default function Home() {
  return (
    <div className="min-h-screen w-full overflow-x-hidden bg-background-50">
      <Header />
      <main>
        <Hero />
        <Testimonials />
        <Banner />
        <Services />
        <TrustedBy />
        <CoverageArea />
        <BusinessInfo />
        <Partners />
        <WhatsNew />
        <Quote />
      </main>
      <Footer />
    </div>
  );
}